import { useRef, cloneElement, isValidElement, ChangeEvent } from "react";
import type { FileButtonProps } from "../../types";

function FileButton({ render, accept, multiple = false, onSelect }: FileButtonProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  const onClick = () => {
    inputRef.current?.click();
  };

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      onSelect(Array.from(event.target.files));
    }
  };

  const rendered = render({ onClick });

  return (
    <>
      {isValidElement(rendered) ? cloneElement(rendered, { key: "button" }) : rendered}
      <input
        key="input"
        type="file"
        accept={accept}
        multiple={multiple}
        onChange={onChange}
        style={{ display: "none" }}
        ref={inputRef}
      />
    </>
  );
}

export default FileButton;
